import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { textStyles } from "../Text";
import { theme } from "../../theme";
import { useScrollShadow } from "../ScrollContainer/useScrollShadow";
import { ShadowElement } from "../ScrollContainer/ScrollContainer";
import { motion } from 'framer-motion';
import { MenuListContext } from "./MenuListContext";
import { darkScrollbarStyles } from "../ScrollContainer/scrollbar-styles";
var VERTICAL_PADDING = theme.spaces[8];
var MenuGroupContainer = styled.div.withConfig({
  displayName: "MenuGroup__MenuGroupContainer",
  componentId: "vapor__sc-1x0o0i9-0"
})(["", " ", ";background-color:var(--popover-background);padding-top:", ";padding-bottom:", ";&:first-child,&:first-child ", "{border-top-right-radius:", ";border-top-left-radius:", ";}&:last-child{border-bottom-right-radius:", ";border-bottom-left-radius:", ";}&:not(:first-child){border-top:1px solid ", ";}"], function (p) {
  return p.$maxHeight && "\n    max-height: ".concat(p.$maxHeight, ";\n    overflow-y: scroll;\n  ");
}, darkScrollbarStyles, VERTICAL_PADDING, VERTICAL_PADDING, ShadowElement, theme.radii[6], theme.radii[6], theme.radii[6], theme.radii[6], theme.colors.border.primary);
var MenuGroupHeader = styled.div.withConfig({
  displayName: "MenuGroup__MenuGroupHeader",
  componentId: "vapor__sc-1x0o0i9-1"
})(["height:calc(", " - ", ");padding:0 ", ";display:flex;align-items:center;cursor:default;color:", ";", ";user-select:none;"], theme.spaces[32], theme.spaces[2], theme.spaces[16], theme.colors.text.tertiary, textStyles.secondary);
/**
 * MenuGroup
 *
 * A collection of MenuItems with an optional label. This should
 * be used any time you want to use Separators in a Menu.
 *
 * @example
 *
 * <Menu
 *  content={
      <>
        <MenuGroup title='A title'>
          <MenuButton>Hello world</MenuButton>
        </MenuGroup>
        <MenuNonInteractiveArea>
          Text description
        </MenuNonInteractiveArea>
      </>
 * } />
 */

export function MenuGroup(_ref) {
  var maxHeight = _ref.maxHeight,
      label = _ref.label,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["maxHeight", "label", "children"]);

  var _useScrollShadow = useScrollShadow(),
      opacity = _useScrollShadow.opacity,
      onScroll = _useScrollShadow.onScroll;

  var _useContext = useContext(MenuListContext),
      expandedId = _useContext.expandedId,
      dispatch = _useContext.dispatch;

  var handleScroll = useCallback(function (e) {
    onScroll(e);

    if (expandedId) {
      dispatch({
        type: 'COLLAPSE_AND_DESELECT',
        mouse: true
      });
    }
  }, [dispatch, expandedId, onScroll]);
  return /*#__PURE__*/React.createElement(MenuGroupContainer, _extends({
    onScroll: maxHeight ? handleScroll : null,
    $maxHeight: maxHeight
  }, other), maxHeight && /*#__PURE__*/React.createElement(ShadowElement, {
    as: motion.div,
    style: {
      transform: "translateY(-".concat(VERTICAL_PADDING, ")"),
      opacity: opacity
    },
    $shouldDisplayTopBorder: false,
    $isShadowVisible: true
  }), label && /*#__PURE__*/React.createElement(MenuGroupHeader, null, label), children);
}